import { variantDanger, variantPrimary, variantSecondary, variantTertiary } from './button';
import { asSingleStyleConfig } from '../../utils/theme';
var menu = {
  border: 'none',
  _hover: {
    bg: 'blue.1140'
  },
  _active: {
    bg: 'blue.1140',
    border: 'none'
  },
  _focus: {
    borderColor: 'blue.550',
    boxShadow: "0 0 0.1875rem 0.125rem #4CAAF0",
    outline: 'none'
  }
};
export default asSingleStyleConfig({
  baseStyle: {
    display: 'flex',
    border: '1px',
    boxSizing: 'border-box',
    alignItems: 'center',
    flexShrink: 0,
    justifyContent: 'center',
    transition: 'all 200ms',
    svg: {
      display: 'unset',
      margin: 0
    }
  },
  variants: {
    primary: props => variantPrimary(props).button,
    secondary: props => variantSecondary(props).button,
    tertiary: props => variantTertiary(props).button,
    danger: props => variantDanger(props).button,
    menu
  },
  sizes: {
    sm: {
      width: 6,
      height: 6
    },
    md: {
      width: 8,
      height: 8
    },
    lg: {
      width: 10,
      height: 10
    }
  },
  defaultProps: {
    size: 'md',
    variant: 'tertiary'
  }
});